import Feature from 'ol/Feature';
import geometry from 'client/utils/format/ol/geometry';
import { ClientWithAuth } from 'client/services/service';
import { getEpsgCode } from 'client/utils/helpers/MapConfig/MapConfig';

const serviceUrlSuffix = '/asset-owner-service';

export default {
    getAssetOwners: async (aoi, aoiDataProviderIds = [], epsgOverride = '') => {
        if (!aoi || !(aoi instanceof Feature)) {
            throw new Error('aoi is NOT instance of ol/Feature');
        }

        // dedupe the aoiDataProviderIds
        aoiDataProviderIds = Array.from(new Set(aoiDataProviderIds));

        const aoiGeometry = aoi.getGeometry();
        const wktGeometry = geometry.toWKT(aoiGeometry);
        const data = {
            wktGeometry,
            aoiDataProviderIds
        };

        const epsgCode = epsgOverride || await getEpsgCode();
        const response = await ClientWithAuth.post(`${serviceUrlSuffix}/${epsgCode}/asset-owner`, data);

        return {
            ...response?.data
        };
    },
    getAllAssetOwnersInMyArea: async () => {
        const epsgCode = await getEpsgCode();
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/${epsgCode}/asset-owner`);
        return { ...response?.data };
    },
    getMyCoverageArea: async () => {
        const epsgCode = await getEpsgCode();
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/${epsgCode}/me/coverage`);
        return { ...response?.data };
    }
};
